






































import Vue from 'vue';
import customerClient from '../../../customer/apis';
import CustomerGroup from '../../../customer/models/CustomerGroup';
import customerVuex from '../../../customer/vuex/common';
import CustomerGroupItem from './CustomerGroupItem.vue';
import CustomerGroupEditBox from './CustomerGroupEditBox.vue';
import commonClient from '../../../common/apis';
import format from '../../../customer/components/filter/makeCustomerQuery';
import { TaskType } from '../../../common/models/TaskType';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    CustomerGroupItem,
    CustomerGroupEditBox,
  },
  props: {
    openids: {
      type: Array as () => number[],
      default: [],
    },
    initIds: {
      type: Array as () => number[],
      default: [],
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedGroupIds: [],
      showAdd: false,
      TaskType,
    };
  },
  computed: {
    customerGroups(): CustomerGroup[] {
      return this.customerState.customerGroups.map((group: CustomerGroup) => {
        return {
          group,
          selected: this.isSelectedGroup(group.id),
        };
      });
    },
  },
  methods: {
    loadGroups() {
      customerClient.getGroups().success((r: any) => {
        this.$store.commit('UPDATE_CUSTOMER_GROUPS', r.groups);
      });
      // if (!this.customerState.customerGroups || this.customerState.customerGroups.length < 1) {
      //   customerClient.getGroups().success((r: any) => {
      //     this.$store.commit('UPDATE_CUSTOMER_GROUPS', r.groups);
      //   });
      // }
    },
    refreshGroups(emit = true) {
      customerClient.getGroups().success((r: any) => {
        this.$store.commit('UPDATE_CUSTOMER_GROUPS', r.groups);
      });
      if (emit) {
        this.$emit('success');
      }
    },
    addGroup(groupName: string) {
      customerClient.addGroup({name: groupName}).success((r) => {
        if (r) {
          this.$Message.success('添加组成功');
          this.showAdd = false;
          this.refreshGroups(false);
        }
      });
    },
    appendGroup(groupId: number, isAdd = true) {
      const index = this.selectedGroupIds.indexOf(groupId);
      if (isAdd) {
        if (index === -1) {
          this.selectedGroupIds.push(groupId);
        }
      } else {
        if (index >= 0) {
          this.selectedGroupIds.splice(index, 1);
        }
      }
    },
    confirmAppendGroup() {
      if (this.selectedGroupIds.length === 0) {
        this.$Message.warning('请选择组别');
      } else {
        commonClient.createTask({
          input: {
            GroupAppend: {
              query: format.mkFilterQueries(this.customerFilter),
              groupIds: this.selectedGroupIds,
            },
          },
          taskType: TaskType.GroupAppend,
          expectCount: this.customerState.customerList.total,
        }).success((r: any) => {
          this.$Message.success({content: '创建添加到组任务成功，请等待完成', duration: 3});
          this.$emit('close');
        }).failure((code: string, msg?: string) => {
          this.$Message.error(msg);
        }).error((e) => {
          this.$Message.error(e.toString());
        });
      }
    },
    isSelectedGroup(id: number): boolean {
      return this.selectedGroupIds.includes(id);
    },
  },
  mounted() {
    this.loadGroups();
    this.selectedGroupIds = JSON.parse(JSON.stringify(this.initIds));
  },
});
